export default __webpack_public_path__ + "static/media/244-south-sudan.7ffe2c58.svg";